const WhyChooseAvexaDigitalHealth = () => {
  const cards = [
    {
      id: 1,
      image: "/assets/digitalHealth/5section-1.svg",
      title: "Healthcare-focused platform expertise",
    },
    {
      id: 2,
      image: "/assets/digitalHealth/5section-2.svg",
      title: "End-to-end digital solution design",
    },
    {
      id: 3,
      image: "/assets/digitalHealth/5section-3.svg",
      title: "Strong emphasis on security and compliance",
    },
    {
      id: 4,
      image: "/assets/digitalHealth/5section-4.svg",
      title: "Scalable and future-ready architectures",
    },
    {
      id: 5,
      image: "/assets/digitalHealth/5section-5.svg",
      title: "Innovation-driven approach",
    },
  ];

  // Duplicate cards for seamless loop
  const allCards = [...cards, ...cards, ...cards];

  return (
    <section className="py-8 md:py-12 lg:py-16 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-10 md:mb-12 lg:mb-14">
          <h2 className="font-bold mb-4 md:mb-5">
            Why Choose Avexa for Digital Health
          </h2>
          <p className="text-heading max-w-4xl mx-auto px-4">
            Trusted digital expertise, secure platforms, and innovation-driven
            solutions built to power the future of healthcare.
          </p>
        </div>
      </div>

      {/* Continuous Scrolling Container */}
      <div className="relative">
        <div className="scroll-container">
          <div className="scroll-content">
            {allCards.map((card, index) => (
              <div
                key={`${card.id}-${index}`}
                className="flex-shrink-0 w-64 md:w-72 lg:w-80 mx-3 md:mx-4"
              >
                <div className="bg-white rounded-xl overflow-hidden transition-shadow duration-300 h-[220px] md:h-[240px] flex flex-col">
                  {/* Image - Fixed height */}
                  <div className="relative h-40 md:h-44 overflow-hidden flex-shrink-0">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  {/* Title - Blue Background Section - Flex grow to fill remaining space */}
                  <div className="primary-bg flex-grow flex items-center justify-center p-3 md:p-4">
                    <p className="text-white leading-tight text-center ">
                      {card.title}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style jsx>{`
        .scroll-container {
          overflow: hidden;
          position: relative;
          width: 100%
        }

        .scroll-content {
          display: flex;
          width: max-content;
          animation: scroll 25s linear infinite;
        }

        .scroll-content:hover {
          animation-play-state: paused;
        }

        /* Mobile: small cards so 3+ are visible */
        .card-wrapper {
          flex-shrink: 0;
          width: 160px;
          margin: 0 8px;
        }
 
        .card-inner {
          height: 190px;
        }
 
        .card-image {
          height: 120px;
        }
 
        /* Tablet: 768px — show ~5 cards */
        @media (min-width: 768px) {
          .card-wrapper {
            width: 200px;
            margin: 0 10px;
          }
 
          .card-inner {
            height: 210px;
          }
 
          .card-image {
            height: 140px;
          }
 
          .scroll-content {
            animation-duration: 30s;
          }
        }
 
        /* Desktop: 1024px+ — original larger sizing */
        @media (min-width: 1024px) {
          .card-wrapper {
            width: 320px;
            margin: 0 16px;
          }
 
          .card-inner {
            height: 240px;
          }
 
          .card-image {
            height: 176px;
          }
 
          .scroll-content {
            animation-duration: 35s;
          }
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .scroll-content {
            animation: none;
            flex-wrap: wrap;
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </section>
  );
};

export default WhyChooseAvexaDigitalHealth;
